<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.payqrcode_delete"
                   @click="handleDelete">删 除
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="permissionList.sellerBtn"
          @click="openLinkSellerForm"
        >设置销售方
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" @click="tip(scope.row.qrCodePath, scope.row.storeName)"
        ><span class="el-icon-download"></span>二维码
        </el-button>
      </template>
      <template slot-scope="scope" slot="logoUploadForm">
        <vupload :disabled="uploadDisabled" :fileList.sync="fileList" :types="uploadTypes" :limit="1" :message="'请上传jpg,png图片'"></vupload>
      </template>

      <template slot-scope="scope" slot="sellerIdForm">
        <el-select
          v-model="form.sellerId"
          :disabled="sellerDisabled"
          style="width: 100%"
          clearable
        >
          <el-option
            v-for="(item,index) in sellerList"
            :key="index"
            :label="item.sellerInfo"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
    </avue-crud>

    <el-dialog
      title="设置销售方"
      v-if="sellerDialogVisible"
      :visible.sync="sellerDialogVisible"
      width="50%"
      :before-close="closeSellerForm"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form ref="sellerFormRef" :model="sellerForm" :rules="sellerRules" label-width="110px" v-if="sellerDialogVisible">
        <el-form-item label="销售方信息" required prop="sellerId">
          <el-select v-model="sellerForm.sellerId" style="width: 100%">
            <el-option
              v-for="(item,index) in sellerList"
              :key="index"
              :label="item.sellerInfo"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="submitSellerInfo" :loading="debounce">确认</el-button>
          <el-button @click="closeSellerForm">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </basic-container>
</template>

<script>
  import {
    add,
    getDetail,
    remove,
    getPage,
    update,
    linkSeller,
  } from "@/api/v4ward/pay/payqrcode";
  import { getAllSellerList } from "@/api/v4ward/digitaltickets/feeSeller";
  import {mapGetters} from "vuex";
  import qrcode from "qrcodejs2";
  import vupload from "@/views/components/v-upload-types";

  export default {
    components:{vupload},
    data() {
      return {
        sellerDisabled:false,
        sellerList:[],
        sellerRules: {
          sellerId: [
            { required: true, message: '请选择销售方信息', trigger: 'blur' },
          ],
        },
        sellerDialogVisible:false,
        sellerForm:{

        },
        debounce:false,
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        uploadTypes:[
          'image/vnd.dwg',
          'image/vnd.dxf',
          'image/jp2',
          'image/jpeg',//
          'image/pjpeg',//jpg 火狐
          'image/x-png',//png
          'image/bmp',//bmp
          'image/x-icon',
          'image/png',
        ],
        uploadDisabled:false,
        fileList:[],
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          labelWidth: 100,
          column: [
            // {
            //   label: '平台商户名称',
            //   prop: 'wpMchId',
            //   searchLabelWidth: 100,
            //   labelWidth: 120,
            //   hide:true,
            //   editDisabled: true,
            //   type: 'select',
            //   dataType: 'string',
            //   props: {
            //     label: 'wpMchName',
            //     value: 'wpMchId'
            //   },
            //   dicUrl: `/api/v4ward/pay/payMerchant/all`,
            //   rules: [
            //     {
            //       required: true,
            //       message: '请选择平台商户名称',
            //       trigger: 'change',
            //     },
            //   ],
            // },
            
            // {
            //   label: '平台商户号',
            //   prop: 'tempWpMchId',
            //   labelWidth: 120,
            //   addDisplay:false,
            //   editDisplay:false,
            //   viewDisplay:true,
            //   editDisabled: true,
            //   rules: [
            //     {
            //       required: true,
            //       message: '请输入平台商户号',
            //       trigger: 'change',
            //     },
            //   ],
            // },
            // {
            //   label: '平台商户名称',
            //   prop: 'wpMchName',
            //   search: true,
            //   searchLabelWidth: 100,
            //   searchSpan:5,
            //   labelWidth: 120,
            //   addDisplay:false,
            //   editDisplay:false,
            //   viewDisplay:false,
            //   rules: [
            //     {
            //       required: true,
            //       message: '请输入平台商户名称',
            //       trigger: 'change',
            //     },
            //   ],
            // },
            {
              label: "门店名称",
              prop: "storeName",
              maxlength:40,
              showWordLimit:true,
              search: true,
              rules: [{
                required: true,
                message: "请输入门店名称",
                trigger: "change"
              }]
            },
            {
              label: "门店编号",
              prop: "storeNo",
              maxlength:40,
              showWordLimit:true,
              search: true,
              rules: [{
                required: false,
                message: "请输入门店编号",
                trigger: "change"
              }]
            },
            
            {
              label: "门店地址",
              prop: "storeAddress",
              maxlength:40,
              showWordLimit:true,
              rules: [{
                required: false,
                message: "请输入门店地址",
                trigger: "change"
              }]
            },
            {
              label: "联系人",
              prop: "contact",
              maxlength:40,
              showWordLimit:true,
              rules: [{
                required: true,
                message: "请输入联系人",
                trigger: "change"
              }]
            },
            {
              label: "联系电话",
              prop: "phone",
              maxlength:11,
              showWordLimit:true,
              rules: [{
                required: true,
                message: "请输入联系电话",
                trigger: "change"
              }]
            },
            {
              label: '所属部门',
              prop: 'deptId',
              searchLabelWidth: 100,
              // hide:true,
              type: 'tree',
              dataType: 'string',
              props: {
                label: 'title',
                value: 'value'
              },
              dicUrl: `/api/v4ward/pay/payQrCode/getUserDept`,
              rules: [
                {
                  required: true,
                  message: '请选择所属部门',
                  trigger: 'change',
                },
              ],
            },
            {
              label: "云喇叭",
              prop: "cloudHorn",
              maxlength:40,
              showWordLimit:true,
            },
            {
              label: "二维码路径",
              prop: "qrCodePath",
              hide:true,
              addDisplay:false,
              editDisplay:false,
              rules: [{
                required: true,
                message: "请输入二维码路径",
                trigger: "change"
              }]
            },
            {
            label: "销售方信息",
            prop: "sellerInfo",
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false,
          },
            {
              label: "销售方信息",
              prop: "sellerId",
              span: 12,
              formslot: true,
              hide: true,
              showColumn:false,
              rules: [{
                required: true,
                message: "请选择销售方",
                trigger: "change"
              }]
            },
            {
              label: "LOGO图片",
              prop: "logoUpload",
              span: 24,
              hide:true,
              formslot: true,
            },
            {
              label: "LOGO图片路径",
              prop: "logoPath",
              hide:true,
              addDisplay:false,
              editDisplay:false,
              viewDisplay:false,
            },

          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          sellerBtn: this.vaildData(this.permission.payqrcode_seller, false),
          addBtn: this.vaildData(this.permission.payqrcode_add, false),
          viewBtn: this.vaildData(this.permission.payqrcode_view, false),
          delBtn: this.vaildData(this.permission.payqrcode_delete, false),
          editBtn: this.vaildData(this.permission.payqrcode_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      openLinkSellerForm() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        getAllSellerList().then((res) => {
          this.sellerList = res.data;
          this.sellerDialogVisible = true;
          this.sellerForm.ids = this.ids;
        });
      },
      submitSellerInfo(){
        this.$refs.sellerFormRef.validate((valid) => {
          console.log('this.sellerForm<<<<', this.sellerForm)
          if (valid) {
            linkSeller(this.sellerForm, {
              showLoading: { text: '处理中...' },
            }).then(() => {
              this.onLoad();
              this.closeSellerForm();
              this.$message.success('操作成功!');
              this.$refs.crud.toggleSelection();
            });
          }
        });
      },
      closeSellerForm(){
        this.sellerForm = {};
        this.sellerDialogVisible = false;
      },
      tip(url, fileName) {
        // tip(url, fileName);
        var div = document.createElement('div');
        var code = new qrcode(div, {
          text: url,
          width: 500,
          height: 500,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: qrcode.CorrectLevel.H,
        });
        let canvas = code._el.querySelector('canvas');
        var base64Text = canvas.toDataURL('image/png');
        var blob = this.getBlob(base64Text);
        if (navigator.msSaveBlob) {
          // IE的Blob保存方法
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement('a');
          var href = window.URL.createObjectURL(blob);
          link.href = href;
          link.download = fileName;
          document.body.appendChild(link); // firefox需要把a添加到dom才能正确执行click
          link.click();
          // 延时保证下载成功执行，否则可能下载未找到文件的问题
          setTimeout(function () {
            window.URL.revokeObjectURL(href); // 释放Url对象
            document.body.removeChild(link);
          }, 100);
        }
      },
      getBlob(base64) {
        var mimeString = base64.split(',')[0].split(':')[1].split(';')[0]; // mime类型
        var byteString = atob(base64.split(',')[1]); //base64 解码
        var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
        var intArray = new Uint8Array(arrayBuffer); //创建视图
        for (var i = 0; i < byteString.length; i += 1) {
          intArray[i] = byteString.charCodeAt(i);
        }
        return new Blob([intArray], {
          type: mimeString,
        });
      },
      rowSave(row, done, loading) {
        if(this.fileList.length > 0){
          row.logoPath = this.fileList[0].link;
        }else{
          row.logoPath = "";
        }

        row.wpMchName = row.$wpMchId;
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        if(this.fileList.length > 0){
          row.logoPath = this.fileList[0].link;
        }else {
          row.logoPath = "";
        }
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        //初始化销售信息
        getAllSellerList().then((res) => {
          this.sellerList = res.data;
        });
        this.fileList = [];
        if(["add"].includes(type)){
          this.uploadDisabled = false;
          this.sellerDisabled = false;
        }
        if (["edit", "view"].includes(type)) {
          this.uploadDisabled = false;
          this.sellerDisabled = false;
          getDetail({id: this.form.id}).then(({data}) => {
            if(this.vdui.isNotEmpty(data.logoPath)){
              let fileNameIndex = data.logoPath.lastIndexOf('/')+1;
              let fileName = data.logoPath.substring(fileNameIndex);
              let startIndex = data.logoPath.lastIndexOf('.')+1;
              let fileType = data.logoPath.substring(startIndex);
              this.fileList.push({originalName:fileName,link:data.logoPath});
            }
            this.form = data;
          });
        }
        if (["view"].includes(type)) {
          this.uploadDisabled = true;
          this.sellerDisabled = true;
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getPage(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          data.records.forEach((e)=>{
            e.tempWpMchId = e.wpMchId;
          })
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
